/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/vector.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the scalar as a vector with no labels.
 *
 * @example
 * vector(1)
 */
const definition: PromqlFunctionDefinition = {
  type: 'vector_conversion',
  name: 'vector',
  signatures: [
    {
      params: [
        {
          name: 's',
          type: 'scalar',
          optional: false,
          description: 'Scalar value.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
